module.exports = __webpack_public_path__ + "static/media/bridge.20c73e8f.svg";